var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "map-big-screen", class: { screen: _vm.isAllScreen } },
    [
      _c("div", { staticClass: "map-big-screen-over" }, [
        _c("div", { staticClass: "map-shadow" }),
        _c("div", { staticClass: "map-shadow down" }),
        _c("div", { ref: "mapContainer", staticClass: "map-container" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }